import { render, staticRenderFns } from "./BatchBindScriptModal.vue?vue&type=template&id=98bb48ba"
import script from "./BatchBindScriptModal.vue?vue&type=script&lang=js"
export * from "./BatchBindScriptModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports